import { combineReducers } from "redux";
import TimeSheetReducer from "./reducer";

const reducer = combineReducers({
  TimeSheetReducer,
});

export default reducer;
